import { useState, useLayoutEffect, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CustomInput from '../../ui/Form/CustomInput';
import { setDataResidence } from './guestsSlice';
import CustomInputPhoneNumber from '../../ui/Form/CustomInputPhoneNumber';
import CountryExtendedList from '../../utils/CountryExtendedList';
import FormErrorsModal from '../../ui/Modals/FormErrorsModal';
import CountrySelect from '../../ui/Form/CountrySelect.';
import { getCountryByCode, isEmptyObject } from '../../utils';
import StateSelect from '../../ui/Form/StateSelect';
import StatesList from '../../utils/StatesList';
import { setErrorMessage } from '../../app/store/majesticSlice';
import usePageNavigation from '../../hooks/usePageNavigation';

function GuestResidenciaPage() {
  const [showErrorsModal, setShowErrorsModal] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const { dataResidence, selectedGuest, guestHolder } = useSelector((state) => state.guests);
  const { nationality } = useSelector((state) => state.ocr);
  const { booking } = useSelector((state) => state.booking);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    control,
    reset,
    trigger,
    register,
    setValue,
    watch,
    formState,
    handleSubmit,
  } = useForm();

  const { navigateNextPage } = usePageNavigation();

  const countryResidence = watch('countryResidence') || {};
  const stateResidence = watch('stateResidence') || {};
  const dataPhone = watch('phoneKey') || {};

  useEffect(() => {
    setValue('stateResidence', dataResidence.state);
  }, [setValue, dataResidence]);

  useEffect(() => {
    if (!isEmptyObject(nationality)) {
      const dataCountry = getCountryByCode(nationality?.iso2);
      setValue('countryResidence', dataCountry);
      setValue('phoneKey', dataCountry);
    }
  }, [setValue, nationality]);

  const onSubmit = (data) => {
    const newDataResidence = {
      country: data.countryResidence,
      // email: selectedGuest.TipoPersona === '3' ? guestHolder.DatosComunicacion.EMail : data.email,
      email: data.email,
      phoneKey: data.phoneKey,
      phoneNumber: data.phoneNumber.replace(/[\s_]/g, ''),
      state: data.stateResidence || {},
      zipCode: data.zipCode || '',
    };

    dispatch(setDataResidence(newDataResidence));
    // console.log(newDataResidence);
    // navigate('/ContractSignature');
    navigateNextPage('ContractSignature');
  };

  const onError = (errorList) => {
    const messages = Object.values(errorList).map((error) => error.message || 'Campo inválido');
    setErrorMessages(messages);
    setShowErrorsModal(true);
    // navigate('/ContractSignature');
  };

  const handleShowStateResidence = () => {
    const allowList = ['CAN', 'USA'];
    return allowList.includes(countryResidence.iso3);
  };

  const handleShowZipCode = () => {
    const allowList = ['MEX', 'DOM'];
    return allowList.includes(countryResidence.iso3);
  };

  const showZipCodeDom = () => (countryResidence.iso3 === 'DOM' && booking.HotelFactura !== 'M4');

  const showZipCodeMex = () => (countryResidence.iso3 === 'MEX' && booking.HotelFactura === 'M4');

  const handleCloseModal = () => {
    // setErrorMessage('');
    setShowErrorsModal(false);
  };

  return (
    <div className="guest__residence d-flex flex-column h-100" id="guest__residence">
      <div className="text-center">
        <p className="mb-0 app-txt-granite pp-fw-figtree-regular">{t('TXT_TITLE_CHECK_IN')}</p>

        <p className="my-3 app-fs-h4 app-lh-h4 app-txt-granite app-fw-notosans-bold">
          {t('TXT_RESIDENCE')}
        </p>

        <p className="mb-3 app-txt-granite-80-dark">{t('TXT_COMPLETE_FIELDS')}</p>
      </div>

      <FormProvider
        control={control}
        handleSubmit={handleSubmit}
        setValue={setValue}
        watch={watch}
        formState={formState}
        register={register}
      >
        <Form onSubmit={handleSubmit(onSubmit, onError)} className="residence__form h-100">
          <div className="d-flex flex-column h-100">
            <CustomInput
              control={control}
              name="email"
              formLabel={t('TXT_EMAIL')}
              typeInput="email"
              maxLength={100}
              defaultValue={dataResidence.email}
              cardClassName="border-transparent transition-border-color border-radius-5"
              rules={{
                required: `${t('TXT_ERROR_INPUT_REQUIRED', { inputName: t('TXT_EMAIL') })}`,
                minLength: {
                  value: 5,
                  message: `${t('TXT_ERROR_MIN_EMAIL')}`,
                },
                maxLength: {
                  value: 100,
                  message: `${t('TXT_ERROR_MAX_EMAIL')}`,
                },
                pattern: {
                  // value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: `${t('TXT_ERROR_DOMAIN_EMAIL')}`,
                },
              }}
              classNames={{
                card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                cardBody: 'px-2 py-1',
                label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-12',
                input: 'app-txt-granite-80-dark text-lowercase app-fs-14',
              }}
            />
            <CountrySelect
              control={control}
              name="countryResidence"
              formLabel={t('TXT_COUNTRY_RESIDENCE')}
              placeHolder={t('TXT_COUNTRY_RESIDENCE')}
              rules={{ required: `${t('TXT_ERROR_INPUT_REQUIRED', { inputName: t('TXT_COUNTRY_RESIDENCE') })}` }}
              defaultValue={countryResidence}
              options={CountryExtendedList}
              classNamePrefix="form-review"
              // controlHeight={24}
              classNames={{
                card: 'border-solid-1 transition-border-color border-gray mb-2',
                cardBody: 'px-2 py-1',
                label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-12',
              }}
            />
            {handleShowStateResidence() && (
              <StateSelect
                control={control}
                name="stateResidence"
                formLabel={t('TXT_STATE_RESIDENCE')}
                placeHolder={t('TXT_STATE_RESIDENCE')}
                rules={{ required: `${t('TXT_ERROR_INPUT_REQUIRED', { inputName: t('TXT_STATE_RESIDENCE') })}` }}
                defaultValue={stateResidence}
                selectedCountry={countryResidence}
                options={StatesList}
                classNamePrefix="form-review"
                // controlHeight={24}
                classNames={{
                  card: 'border-solid-1 transition-border-color border-gray mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-12',
                }}
              />
            )}

            {(showZipCodeDom() || showZipCodeMex()) && (
              <CustomInput
                control={control}
                name="zipCode"
                formLabel={t('TXT_ZIP_CODE')}
                defaultValue={dataResidence.zipCode}
                maxLength={5}
                minLength={5}
                cardClassName="border-transparent transition-border-color border-radius-5"
                clearCaracter
                regexClear="[^0-9]"
                rules={{
                  required: `${t('TXT_ERROR_INPUT_REQUIRED', { inputName: t('TXT_ZIP_CODE') })}`,
                  minLength: {
                    value: 5,
                    message: `${t('TXT_ERROR_MIN_ZIP_CODE')}`,
                  },
                  maxLength: {
                    value: 5,
                    message: `${t('TXT_ERROR_MAX_ZIP_CODE')}`,
                  },
                }}
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-12',
                  input: 'app-txt-granite-80-dark text-lowercase app-fs-14',
                }}
              />
            )}
            <div className="d-flex">
              <CountrySelect
                control={control}
                name="phoneKey"
                formLabel={t('TXT_KEY')}
                placeHolder={t('TXT_KEY')}
                rules={
                  {
                    // required: `${t('TXT_ERROR_THE_INPUT_REQUIRED', { inputName: t('TXT_KEY') })}`,
                    // validate: (value) => {
                    //   if (selectedGuest.TipoPersona !== '3' && !value) {
                    //     return `${t('TXT_ERROR_THE_INPUT_REQUIRED', { inputName: t('TXT_KEY') })}`;
                    //   }
                    //   return true;
                    // },
                  }
                }
                defaultValue={dataPhone}
                options={CountryExtendedList}
                classNamePrefix="form-review"
                controlHeight={24}
                styles={{ width: '150px' }}
                // classNames={{
                //   card: 'rounded-end-0 border-solid-1 border-transparent transition-border-color border-radius-5',
                //   cardBody: 'ps-2',
                // }}
                classNames={{
                  card: 'rounded-end-0 border-solid-1 transition-border-color border-gray mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-12',
                }}
              />
              <CustomInputPhoneNumber
                control={control}
                name="phoneNumber"
                formLabel={t('TXT_TELEPHONE')}
                defaultValue={dataResidence.phoneNumber}
                rules={{
                  // required: `${t('TXT_ERROR_INPUT_REQUIRED', { inputName: t('TXT_TELEPHONE') })}`,
                  // validate: (value) => {
                  //   if (selectedGuest.TipoPersona !== '3' && !value) {
                  //     return `${t('TXT_ERROR_THE_INPUT_REQUIRED', { inputName: t('TXT_TELEPHONE') })}`;
                  //   }
                  //   return true;
                  // },
                  minLength: {
                    value: 9,
                    message: `${t('TXT_ERROR_MIN_TELEPHONE')}`,
                  },
                  maxLength: {
                    value: 15,
                    message: `${t('TXT_ERROR_MAX_TELEPHONE')}`,
                  },
                }}
                // cardClassName="rounded-start-0 border-transparent transition-border-color border-radius-5 w-100"
                classNames={{
                  card: 'rounded-start-0 border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-12',
                  input: 'app-txt-granite-80-dark text-lowercase app-fs-12',
                }}
              />
            </div>
            <div className="d-flex flex-grow-1 align-items-end pb-2">
              <Button
                variant=""
                type="submit"
                // disabled={!isValid}
                className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height border-0"
              >
                {t('TXT_BOTON_CONTINUE')}
              </Button>
            </div>
          </div>
        </Form>
      </FormProvider>

      <FormErrorsModal
        showModal={showErrorsModal}
        errorMessageList={errorMessages}
        setShowModal={setShowErrorsModal}
        handleCloseModal={handleCloseModal}
      />
    </div>
  );
}

export default GuestResidenciaPage;
